import { httpClient } from "@/shared/api";

import type { MasterPortfolioPhoto, PhotoOrderItem } from "../model/types";
import type {
  ListMasterPortfolioPhotosResponseDTO,
  MasterPortfolioPhotoDTO,
  UploadMasterPortfolioPhotoResponseDTO,
} from "./dto";

function dtoToPhoto(dto: MasterPortfolioPhotoDTO): MasterPortfolioPhoto {
  return {
    id: dto.id,
    url: dto.url,
    position: dto.position,
    serviceId: dto.service_id,
  };
}

export interface UploadPortfolioOpts {
  serviceId?: string;
  onProgress?: (pct: number | "indeterminate") => void;
  signal?: AbortSignal;
}

export async function listPortfolioPhotos(masterId: string): Promise<MasterPortfolioPhoto[]> {
  const { data } = await httpClient.get<ListMasterPortfolioPhotosResponseDTO>(
    `/masters/${masterId}/portfolio/photos`,
  );
  return data.photos.map(dtoToPhoto);
}

export async function uploadPortfolioPhoto(
  masterId: string,
  file: File,
  opts?: UploadPortfolioOpts,
): Promise<MasterPortfolioPhoto> {
  const form = new FormData();
  form.append("photo", file);
  if (opts?.serviceId) {
    form.append("service_id", opts.serviceId);
  }
  const { data } = await httpClient.post<UploadMasterPortfolioPhotoResponseDTO>(
    `/masters/${masterId}/portfolio/photos`,
    form,
    {
      signal: opts?.signal,
      onUploadProgress: (e) => {
        if (opts?.onProgress) {
          const pct = e.total ? Math.round((e.loaded / e.total) * 100) : "indeterminate";
          opts.onProgress(pct);
        }
      },
    },
  );
  return dtoToPhoto(data.photo);
}

export async function deletePortfolioPhoto(masterId: string, photoId: string): Promise<void> {
  await httpClient.delete(`/masters/${masterId}/portfolio/photos/${photoId}`);
}

export async function reorderPortfolioPhotos(
  masterId: string,
  order: PhotoOrderItem[],
): Promise<MasterPortfolioPhoto[]> {
  const { data } = await httpClient.put<ListMasterPortfolioPhotosResponseDTO>(
    `/masters/${masterId}/portfolio/photos/order`,
    { order },
  );
  return data.photos.map(dtoToPhoto);
}
